import CardCredentialIdentityScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialIdentityScreen/CardCredentialIdentityScreen';
import React from 'react';

export default function ProgressTrackerP2PCardCredentialIdentityPage() {
  return (
    <CardCredentialIdentityScreen
      otpPath="/progress-tracker-funding/p2p/credential-challenge/[cardId]/verify-otp"
      returnPath="/progress-tracker-funding/p2p/debit"
    />
  );
}
